"use client";

import React from "react";
import { Coffee } from 'lucide-react';

const Whatis = () => {
  return (
    <section className="py-20 bg-gray-100">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-semibold text-center mb-12 text-black">
          Why Choose SEOZast?
        </h2>
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {[
            {
              title: '🔍 Real Web Analysis',
              content: 'Scrape sites and find low-competition keywords in seconds, no AI guesswork.',
            },
            {
              title: '✍️ Seamless AI Articles',
              content: 'Generate SEO-optimized articles and deploy to GitHub or download with one click.',
            },
            {
              title: '💸 Cheaper Than Your Coffee',
              content: 'Full SEO automation for just €5/month — no expensive tools needed.',
              icon: <Coffee className="w-5 h-5 text-emerald-500 inline-block ml-1" />,
            },
          ].map((card, i) => (
            <div
              key={i}
              className="text-black bg-white p-6 rounded-lg shadow-lg border-t-4 border-emerald-500 hover:shadow-xl transition"
            >
              <h3 className="text-lg font-medium text-emerald-600 mb-3 flex items-center">
                {card.title}
                {card.icon && card.icon}
              </h3>
              <p className="text-base text-gray-900 leading-relaxed">{card.content}</p>
            </div>
          ))}
        </div>

        {/* Comparison Section */}
        <div className="mt-12">
          <h3 className="text-2xl font-semibold text-center mb-8 text-black">
            Seozast vs. Other SEO Tools
          </h3>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-emerald-100 p-6 rounded-lg shadow-md border border-gray-200">
              <h4 className="text-lg font-medium text-emerald-600 mb-4 flex items-center">
                <Coffee className="w-5 h-5 mr-2" />
                Seozast
              </h4>
              <ul className="text-sm text-gray-900 space-y-2">
                <li className="flex items-start">
                  <span className="text-emerald-500 mr-2">✔</span>
                  SEO-optimized articles with high-ranking keywords
                </li>
                <li className="flex items-start">
                  <span className="text-emerald-500 mr-2">✔</span>
                  Fully automated: scrape, generate, edit, and deploy
                </li>
                <li className="flex items-start">
                  <span className="text-emerald-500 mr-2">✔</span>
                  Multiple formats: text, markdown, Word, or Next.js TSX/JSX
                </li>
                <li className="flex items-start">
                  <span className="text-emerald-500 mr-2">✔</span>
                  One-click GitHub deployment
                </li>
                <li className="flex items-start">
                  <span className="text-emerald-500 mr-2">✔</span>
                  Unique, tailored content with backlinks
                </li>
                <li className="flex items-start">
                  <span className="text-emerald-500 mr-2">✔</span>
                  Integrated Pexels images for articles
                </li>
                <li className="flex items-start">
                  <span className="text-emerald-500 mr-2">✔</span>
                  Manage multiple sites seamlessly
                </li>
                <li className="flex items-start">
                  <span className="text-emerald-500 mr-2">✔</span>
                  Just €5/month — cheaper than your coffee
                </li>
              </ul>
            </div>
            <div className="bg-red-100 p-6 rounded-lg shadow-md border border-gray-200">
              <h4 className="text-lg font-medium text-gray-600 mb-4">
                Other SEO Tools
              </h4>
              <ul className="text-sm text-gray-900 space-y-2">
                <li className="flex items-start">
                  <span className="text-red-500 mr-2">✘</span>
                  Generic content requiring manual SEO tweaks
                </li>
                <li className="flex items-start">
                  <span className="text-red-500 mr-2">✘</span>
                  Limited or no automation for publishing
                </li>
                <li className="flex items-start">
                  <span className="text-red-500 mr-2">✘</span>
                  Limited to one format
                </li>
                <li className="flex items-start">
                  <span className="text-red-500 mr-2">✘</span>
                  No GitHub integration or developer-friendly outputs
                </li>
                <li className="flex items-start">
                  <span className="text-red-500 mr-2">✘</span>
                  Repetitive, formulaic content with no backlinks
                </li>
                <li className="flex items-start">
                  <span className="text-red-500 mr-2">✘</span>
                  Low-quality or unusable AI-generated images
                </li>
                <li className="flex items-start">
                  <span className="text-red-500 mr-2">✘</span>
                  No support for managing multiple sites
                </li>
                <li className="flex items-start">
                  <span className="text-red-500 mr-2">✘</span>
                  Expensive subscriptions, often €50+/month
                </li>
              </ul>
            </div>
          </div>
          <p className="text-center text-gray-600 mt-6 text-sm">
            Seozast: Affordable, automated SEO for developers and creators
          </p>
        </div>
      </div>
    </section>
  );
};

export default Whatis;